export const firebaseConfig = {
  apiKey: 'AIzaSyBrG5GmplxwBeBBnBU2p4o2mHzT_k4Eons',
  authDomain: 'extend-app-stage.firebaseapp.com',
  projectId: 'extend-app-stage',
  storageBucket: 'extend-app-stage.appspot.com',
  messagingSenderId: '119334264424',
  appId: '1:119334264424:web:ae0fe94cea6ed5fcc325dd',
  measurementId: 'G-TYKZ07LQCC',
}

export const firebaseConfigProd = {
  apiKey: 'AIzaSyBrG5GmplxwBeBBnBU2p4o2mHzT_k4Eons',
  authDomain: 'extend-app-stage.firebaseapp.com',
  projectId: 'extend-app-stage',
  storageBucket: 'extend-app-stage.appspot.com',
  messagingSenderId: '119334264424',
  appId: '1:119334264424:web:d6828c059778d28dc325dd',
  measurementId: 'G-FZEX4991NX',
}
